import { dropRight } from 'lodash';

const MAX_ENTRIES_COUNT = 200;

export const addEntryToDashboardList = <T>(entry: T, list: T[]) => {
  return list.length === MAX_ENTRIES_COUNT
    ? [entry, ...dropRight(list)]
    : [entry, ...list];
};
